import { render, staticRenderFns } from "./VisualizarDisciplinaDialog.vue?vue&type=template&id=6ca775b5"
import script from "./VisualizarDisciplinaDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarDisciplinaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports